import React from "react";

/** Coins — two overlapping flat coins (Lucide/Figma), outer 40×40 */
const CoinsIcon = ({ className, ...rest }: React.SVGProps<SVGSVGElement>) => {
    return (
        <span className="relative inline-block size-10 shrink-0 overflow-hidden" aria-hidden>
            <span className="absolute inset-[12.5%]">
                <svg
                    className={className ?? "block size-full"}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...rest}
                >
                    <circle
                        cx="8"
                        cy="8"
                        r="6"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18.09 10.37A6 6 0 1 1 10.34 18"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7 6h1v4"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="m16.71 13.88.7.71-2.82 2.82"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    );
};

export default CoinsIcon;
